import { ColumnSpanConfig } from "../blocks/layout/GridColumn.types";
import { TableTabConfig } from "./tableConfig.types";
import { StageConfig } from "../render/fieldConfig.types";

/** A stage of form fields. */
export interface StageBlock {
  kind: "stage";
  stage: StageConfig;
}

/** The entity's related-record tables, wherever the layout places them. */
export interface TablesBlock {
  kind: "tables";
  title?: string;
  tabs: TableTabConfig[];
}

export type PageBlock = StageBlock | TablesBlock;

export interface StageColumn {
  /** Column width per breakpoint, same convention as FieldConfig's span. */
  span: ColumnSpanConfig;
  /** Draws the column as one card, with the sections inside it plain. */
  card?: boolean;
  /** Only inside a card: grows the card to the height of its row. */
  fillHeight?: boolean;
  /** Blocks stacked top-to-bottom within this column. */
  blocks: PageBlock[];
}

export interface StageRow {
  columns: StageColumn[];
}

/** The stages in a set of rows, for the save payload and name lookups. */
export function getStages(rows: StageRow[]): StageConfig[] {
  return rows
    .flatMap((row) => row.columns)
    .flatMap((column) => column.blocks)
    .filter((block): block is StageBlock => block.kind === "stage")
    .map((block) => block.stage);
}
